// src/utils/formatters.js
/**
 * Форматирование цены
 */
export const formatPrice = (price, currency = '₽') => {
  if (price === null || price === undefined) return 'По запросу';
  const num = typeof price === 'string' ? parseFloat(price) : price;
  return `${num.toLocaleString('ru-RU')} ${currency}`;
};

/**
 * Форматирование даты
 */
export const formatDate = (date, format = 'ru') => {
  if (!date) return '';
  const d = new Date(date);
  if (format === 'ru') {
    return d.toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }
  return d.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

/**
 * Форматирование даты с временем
 */
export const formatDateTime = (date) => {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

/**
 * Обрезка текста
 */
export const truncateText = (text, maxLength = 100) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
};

/**
 * Генерация URL для изображения
 */
export const getImageUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return `${API_BASE_URL}/uploads/${path}`;
};

/**
 * Плюрализация
 */
export const pluralize = (count, one, few, many) => {
  if (count % 10 === 1 && count % 100 !== 11) return one;
  if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) return few;
  return many;
};